module.exports = __webpack_public_path__ + "static/media/11.ada6a905.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/japan-four/11.jpg
// module id = 441
// module chunks = 0